export const EventDetailsTableColumns = {
  columnsConfig: [
    {
      title: "Group",
      dataIndex: "event_group",
      key: "event_group",
      fixed: "left",
      valueRenderingType: "event_group",
    },
    {
      title: "Event Type",
      dataIndex: "eventType",
      key: "eventType",
      defaultValue: "-",
      textFormat: "title",
      valueRenderingType: "text",
    },
    {
      title: "Start Time",
      dataIndex: "startTime",
      key: "startTime",
      defaultValue: "-",
      valueRenderingType: "timestamp",
      disableTimezone: true,
      dateFormat: "hh:mm A",
    },
    {
      title: "End Time",
      dataIndex: "endTime",
      key: "endTime",
      defaultValue: "-",
      valueRenderingType: "timestamp",
      disableTimezone: true,
      dateFormat: "hh:mm A",
    },
    {
      title: "Charge Type",
      dataIndex: "chargeType",
      key: "chargeType",
      defaultValue: "-",
      textFormat: "title",
      valueRenderingType: "text",
    },
    {
      title: "Event Duration",
      dataIndex: "durationMinutes",
      key: "durationMinutes",
      defaultValue: "-",
      starting: "minutes",
      valueRenderingType: "deltaTime 2",
    },
    {
      title: "Start SOC (%)",
      dataIndex: "startSoc",
      key: "startSoc",
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "End SOC (%)",
      dataIndex: "endSoc",
      key: "endSoc",
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "Charge Energy Consumed (kWh)",
      dataIndex: "chargeEnergyConsumed",
      key: "chargeEnergyConsumed",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "Discharge Energy Consumed (kWh)",
      dataIndex: "dischargeEnergyConsumed",
      key: "dischargeEnergyConsumed",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "Distance (km)",
      dataIndex: "distance",
      key: "distance",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "BMS SOH (%)",
      dataIndex: "bmsSoh",
      key: "bmsSoh",
      decimalPlaces: 0,
      defaultValue: "-",
      width: 200,
      valueRenderingType: "progress-bar",
    },
    {
      title: "Depot",
      dataIndex: "originDepo",
      key: "originDepo",
      defaultValue: "-",
      valueRenderingType: "text",
    },
    {
      title: "Calculated Charge Energy (kWh)",
      dataIndex: "calculatedChargeEnergy",
      key: "calculatedChargeEnergy",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "Data Gap (%)",
      dataIndex: "dataGapPercent",
      key: "dataGapPercent",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "Ideal Charging Energy (kWh)",
      dataIndex: "idealChargingEnergy",
      key: "idealChargingEnergy",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "kWh/km",
      dataIndex: "kwhPerKm",
      key: "kwhPerKm",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "kWh/SOC",
      dataIndex: "kwhPerSoc",
      key: "kwhPerSoc",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "km/SOC",
      dataIndex: "kmPerSoc",
      key: "kmPerSoc",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "Max Temperature (C)",
      dataIndex: "maxTemperature",
      key: "maxTemperature",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "Min Temperature (C)",
      dataIndex: "minTemperature",
      key: "minTemperature",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "Regen Energy (kWh)",
      dataIndex: "regenEnergy",
      key: "regenEnergy",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "Regen Energy (%)",
      dataIndex: "regenEnergyPercent",
      key: "regenEnergyPercent",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
    {
      title: "Temperature Diff (C)",
      dataIndex: "temperatureDiff",
      key: "temperatureDiff",
      decimalPlaces: 2,
      defaultValue: "-",
      valueRenderingType: "number",
    },
  ],
  columnOrdering: [
    "event_group",
    "startTime",
    "endTime",
    "kwhPerKm",
    "kwhPerSoc",
    "kmPerSoc",
    "startSoc",
    "endSoc",
    "distance",
    "chargeEnergyConsumed",
    "dischargeEnergyConsumed",
    "regenEnergy",
    "regenEnergyPercent",
    "calculatedChargeEnergy",
    "idealChargingEnergy",
    "chargeType",
    "durationMinutes",
    "dataGapPercent",
    "maxTemperature",
    "minTemperature",
    "temperatureDiff",
    "bmsSoh",
    "eventType",
  ],
};
